import React, { useState } from "react";
import { Globe } from "react-feather";
import { LI } from "../../../AbstractElements";
import { useTranslation } from "react-i18next";
import { English } from '../../../Constant';
import { UncontrolledTooltip } from "reactstrap";

const LANGUAGE_NAV_TARGET_ID = "header-language-nav";

const Language = () => {
  const [open, setOpen] = useState(false);

  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  const LanguageSelection = (open) => {
    if (open) {
      setOpen(!open);
    } else {
      setOpen(!open);
    }
  };
  return (
    <>
      <LI attrLI={{ className: "language-nav", id: LANGUAGE_NAV_TARGET_ID }}>
        <div className={`translate_wrapper ${open ? "active" : ""}`}>
          <div className="current_lang">
            <div className="lang" onClick={() => LanguageSelection(open)}>
              <Globe />
            </div>
          </div>
          <ul className={`more_lang ${open ? "active" : ""}`}>
            <div className="lang" onClick={() => changeLanguage('en')}>
              <i className="flag-icon m-0 flag-icon-us"></i>
              <span className="lang-txt">
                {English}
                <span> {'(US)'}</span>
              </span>
            </div>
            <div className="lang" onClick={() => changeLanguage('ru')}>
              <i className="flag-icon m-0 flag-icon-ru"></i>
              <span className="lang-txt">
                Русский
                <span> {'(RU)'}</span>
              </span>
            </div>
          </ul>
        </div>
      </LI>
      <UncontrolledTooltip
        placement="bottom"
        target={LANGUAGE_NAV_TARGET_ID}
      >
        Язык
      </UncontrolledTooltip>
    </>
  );
};

export default Language;
